// Language Detection API Service
import { environment } from '../../../environments/environment';

const API_BASE_URL = environment.backendUrl;

export interface Language {
  id: string;
  label: string;
}

export interface LanguageDetectionResponse {
  languages: Language[];
  country_code: string;
  status: string;
}

export const detectUserLanguages = async (): Promise<LanguageDetectionResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/get-user-languages`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: LanguageDetectionResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error detecting user languages:', error);
    
    // Fallback to default international languages
    return {
      languages: [
        { id: 'hindi', label: 'Hindi' },
        { id: 'spanish', label: 'Spanish' },
        { id: 'french', label: 'French' },
        { id: 'russian', label: 'Russian' },
        { id: 'bengali', label: 'Bengali' },
        { id: 'chinese', label: 'Chinese' },
        { id: 'arabic', label: 'Arabic' },
        { id: 'urdu', label: 'Urdu' },
        { id: 'haitian_creole', label: 'Haitian Creole' },
        { id: 'uzbek', label: 'Uzbek' },
        { id: 'tadzhik', label: 'Tadzhik' },
        { id: 'portuguese', label: 'Portuguese' }
      ],
      country_code: 'unknown',
      status: 'fallback'
    };
  }
};
